import { GradeType } from '@shared/enums/grade-type';
import { VariantType } from '@shared/enums/variant-type';
import { ViewerProductTypes } from '@shared/viewer/enums/viewer-product-types';

export enum ViewerEdition {
  Texas = 'tx',
  TexasSampling = 'txs',
  National = 'ntl',
  Any = 'any',
}

export enum ViewerLanguage {
  en = 'en',
  es = 'es',
  English = 'English',
  Spanish = 'Spanish',
}

export enum ViewerProduct {
  hw = 'hw',
  laesc = 'hw',
  spcn = 'spcn',
  jiw = 'jump',
  wordh = 'wh',
  wh = 'wh',
  gum = 'gum',
  ww = 'ww',
  sk = 'sk',
  fsk = 'fsk',
  hea = 'hea',
  ksn = 'ksn',
  kenc = 'kenc',
  ece = 'ece',
}

export interface IViewerMeta {
  edition?: ViewerEdition;
  language?: ViewerLanguage;
  series?: string;
  /**
   * The grade designation of the asset. Can be None.
   */
  grade?: GradeType;
  /**
   * The variant designation of the asset. Can be None.
   */
  variant?: VariantType;
  /**
   * The variant designation of the asset needed for the viewer api. Can be None.
   */
  viewerVariant?: VariantType;
  product?: ViewerProductTypes;
  topicKey?: string;
}

/**
 * Gets the edition enum from string value.
 */
export const getEditionFromValue = (value: string): ViewerEdition => {
  if (value === 'n') {
    return ViewerEdition.National;
  }
  if (value === 'tx') {
    return ViewerEdition.Texas;
  }
  if (value === 'txs') {
    return ViewerEdition.TexasSampling;
  }

  return ViewerEdition.National;
};
